import { render, staticRenderFns } from "./dualListWithLabels.vue?vue&type=template&id=5a285d0d&"
import script from "./dualListWithLabels.vue?vue&type=script&lang=js&"
export * from "./dualListWithLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports